<template>
  <div class="app-container">
    <div style="position:absolute;right:31px;z-index:999">
      <el-button type="text" @click="sumsAlert">点击查看统计</el-button>
    </div>
    <el-tabs v-model="listQuery.bc" @tab-click="getList()" type="border-card">
      <el-tab-pane label="全部发票" :name="3"></el-tab-pane>
      <el-tab-pane label="已补充" :name="1"></el-tab-pane>
      <el-tab-pane label="未补充" :name="2"></el-tab-pane>
      
      <div class="fl">
        <selectInvoiceType v-model:invoiceType="listQuery.invoiceType" @success="getList"></selectInvoiceType>
        <el-input v-model="listQuery.fphm" placeholder="购方名称/发票号码" @keyup.enter.native="getList" style="width:150px;margin-right:5px" size="mini"></el-input>
        <el-button style="margin-right:5px" size="mini" @click="getList" type="primary" :icon="Search">搜索</el-button>
        <search @success="getList">
          <el-form style="margin:21px 0px 0px 6px;height:277px;width:430px" class="styleForm">
            <el-form-item label="开票日期 ：" :label-width="formLabelWidth">
              <el-date-picker
                size="mini"
                v-model="listQuery.rq"
                type="daterange"
                range-separator="-"
                start-placeholder="开始账期"
                end-placeholder="结束账期"
                style="width:80%;margin-left:5px"
              />
            </el-form-item>
            <el-form-item label="税目 ：" :label-width="formLabelWidth" prop="taxId">
              <shuimu v-model:taxId="listQuery.taxId" v-model:taxRate="listQuery.taxRate"></shuimu>
            </el-form-item>
            <el-form-item label="商品编码 ：" :label-width="formLabelWidth" prop="taxId">
              <ssflbm v-model:ssflbm="listQuery.ssflbm"></ssflbm>
            </el-form-item>
            <el-form-item label="发票来源 ：" :label-width="formLabelWidth">
              <el-select v-model="listQuery.upload" placeholder="请选择来源" size="mini" @change="getList">
                <el-option v-for="item in fromOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="凭证状态 ：" :label-width="formLabelWidth">
              <el-radio-group v-model="listQuery.voucher">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">已生成</el-radio>
                <el-radio :label="2">未生成</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="结算状态：" :label-width="formLabelWidth">
              <el-radio-group v-model="listQuery.js">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">已结算</el-radio>
                <el-radio :label="2">未结算</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </search>
      </div>
      <div class="fr" style="margin-bottom:10px">
        <el-dropdown split-button type="success" @click="addOutput" size="mini" style="margin-right:10px" :hide-on-click="false">
          添加
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <span size="mini" @click="openCom">销项导入</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span size="mini" @click="openComShougou" style="margin-top:10px">收购发票导入</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span size="mini" @click="collect">单张采集</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-button size="mini" type="danger" @click="delALL()" :loading="loading">批量删除</el-button>
        <el-button  type="danger" @click="handleBuchongstatus()" plain size="mini">批量补充</el-button>
        <settings name="设置" :type="['code_xxse']"></settings>
        <el-dropdown size="mini" style="margin-left:10px">
          <el-button size="mini" type="primary">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="a">
                <span @click="handleCommand">一键生成凭证</span>
              </el-dropdown-item>
              <el-dropdown-item command="b">
                <span @click="exportOutput">导出</span>
              </el-dropdown-item>
              <el-dropdown-item command="c">
                <span @click="singleDayin">单张打印销售明细</span>
              </el-dropdown-item>
              <el-dropdown-item command="d">
                <span @click="HebingDayin">合并单位打印销售明细</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="top_title clearfix">
        <div class="left_box fl" @click="allSelect">
          <input type="checkbox" :checked="isAllSelected" />
        </div>
        <div class="top-nav right_box fl">
          <el-row>
          <el-col :span="3">
            <div class="box-content" style="border-left:none;">业务类型</div>
          </el-col>
          <el-col :span="3">
            <div class="box-content">税目</div>
          </el-col>
          <el-col :span="5">
            <div class="box-content">开票项目</div>
          </el-col>
          <el-col :span="4">
            <div class="box-content">补充项目</div>
          </el-col>
          <el-col :span="2">
            <div class="box-content">数量</div>
          </el-col>
          <el-col :span="2">
            <div class="box-content">金额</div>
          </el-col>
          <el-col :span="1">
            <div class="box-content">税率</div>
          </el-col>
          <el-col :span="2">
            <div class="box-content">税额</div>
          </el-col>
          <el-col :span="2">
            <div class="box-content">价税合计</div>
          </el-col>
          </el-row>
        </div>
      </div>

      <div class="table_height" :style="{height:contentStyleObj}" v-loading="loadingBig">
        <div class="content_center clearfix" style="margin-bottom:10px;" v-for="(item,index) in list" :key="index">
          <div class="left_box fl" @click="singleSelect(item, index)">
            <input type="checkbox" :checked="item.checked" />
          </div>
          <div class="content-nav right_box fl">
            <el-row class="content-top">
              <el-col :span="24" class="box-content clearfix">
                <ul class="top_font clearfix">
                  <li style="width:62px">
                    <span style="color:green" v-if="item.invoiceType == '1'">（专）</span>
                    <span style="color:#d56400" v-else-if="item.invoiceType == '2'">（普）</span>
                    <span style="color:#d56400" v-else-if="item.invoiceType == '3'">（无票）</span>
                    <span style="color:green" v-else-if="item.invoiceType == '4'">（电专）</span>
                    <span style="color:#d56400" v-else-if="item.invoiceType == '5'">（电普）</span>
                  </li>
                  <li style="width:130px">发票号码:
                    <span style="color:green" v-if="item.invoiceType == '1' || item.invoiceType == '4'">{{item.fphm}}</span>
                    <span style="color:#d56400" v-if="item.invoiceType == '2' || item.invoiceType == '5'">{{item.fphm}}</span>
                    <span style="color:#d56400" v-if="item.invoiceType == '3'">{{item.fphm}}</span>
                  </li>
                  <el-tooltip effect="dark" :content="item.corpName" placement="top" :disabled="!item.corpName">
                    <li style="width:220px" class="ccyc">购方:
                      <span >{{item.corpName}}</span>
                    </li>
                  </el-tooltip>
                  <li style="width:136px">开票日期:
                    <span>{{$parseTime(item.invoiceDate, "{y}-{m}-{d}")}}</span>
                  </li>
                  <li style="width:110px">结算状态:
                    <span v-if="item.settlementStatus == 1" style="color:green">已结算</span>
                    <span v-else style="color:red">未结算</span>
                  </li>
                  <li style="width:110px">凭证：
                    <span style="color:#39b0d2;text-decoration:underline;cursor:pointer;font-weight:600" v-if="item.voucherNo" @click="getHandlePingzheng(item.voucherId)">{{item.voucherNo}}</span>
                    <span style="color:#39b0d2;;cursor:pointer" v-else type="text" size="mini" @click="showVoucher(item)">生成凭证</span>
                  </li>
                </ul>
                <div class="top_right_btns">
                  <el-tooltip content="编辑" placement="top" >
                    <i @click="goInfo(item.id)" class="el-icon-edit" ></i>
                  </el-tooltip>
                  <el-tooltip content="删除" placement="top" >
                    <i @click="delInvoice(item)" class="el-icon-delete"></i>
                  </el-tooltip>
                </div>
              </el-col>
            </el-row>
            <div class="center_big clearfix">
              <div class="content" v-for="(itemw,index2) in item.items" :key="index2">
                <el-row class="for-content">
                  <el-col :span="3">
                    <div class="box-content">{{itemw.subjectName}}</div>
                  </el-col>
                  <el-tooltip effect="dark" :content="itemw.taxName" placement="top" :disabled="!itemw.taxName">
                    <el-col :span="3">
                      <div class="box-content ccyc">{{itemw.taxName}}</div>
                    </el-col>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="itemw.name" placement="top" :disabled="!itemw.name">
                    <el-col :span="5">
                      <div class="box-content ccyc">{{itemw.name}}</div>
                    </el-col>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="itemw.itemName" placement="top" :disabled="!itemw.itemName">
                    <el-col :span="4">
                      <div class="box-content ccyc">{{itemw.itemName}}</div>
                    </el-col>
                  </el-tooltip>
                  
                  <el-col :span="2">
                    <div class="box-content">{{itemw.count}}</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="box-content">{{itemw.amount}}</div>
                  </el-col>
                  <el-col :span="1">
                    <div class="box-content">{{itemw.taxRate}}</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="box-content">{{itemw.tax}}</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="box-content">{{itemw.total}}</div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <el-row class="bottom-content ">
              <el-col :span="17">
                <div class="box-content">合计</div>
              </el-col>

              <el-col :span="2">
                <div class="box-content">{{item.sumAmount}}</div>
              </el-col>
              <el-col :span="1">
                <div class="box-content"></div>
              </el-col>
              <el-col :span="2">
                <div class="box-content">{{item.sumTax}}</div>
              </el-col>
              <el-col :span="2">
                <div class="box-content">{{item.sumTotal}}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>



      <div class="bottom_style">
        <div class="bottom_button">
        </div>
        <div class="pagination">
          <qzf-pagination v-show="total>0" :total="total" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
        </div>
      </div>
    </el-tabs>
 
    <qzf-import-back :hideButton="true" @success="getList()" from="销项" ref="importBack"></qzf-import-back>
    <qzf-import-back :hideButton="true" @success="getList()" from="收购" ref="importBackShougou"></qzf-import-back>
    <voucher-show ref="voucherShow" from="2" @success="getList"></voucher-show>
    <outbc @success="outbcSuccess" ref="outbc"></outbc>
    <collectSingle ref="collectSingle" @success="getList()"></collectSingle>

  </div>
</template>

<script>
import ssflbm from '@/components/ssflbm/ssflbm.vue'
import shuimu from '@/components/ssflbm/shuimu.vue'
import outbc from './invoiceComponents/outbc.vue' 
import selectInvoiceType from "./selectInvoiceType.vue"
import collectSingle from "./collectSingle.vue"

import { outInvoiceList , delOutInvoice ,inOutSum} from '@/api/invoice.js'
import { oneKeyVoucher } from '@/api/voucher'
export default {
  name:'income',
  components: {
    outbc,
    ssflbm,
    shuimu,
    selectInvoiceType,
    collectSingle
  },
  data() {
    return {
      selects: [],
      listQuery: {
        page: 1,
        limit: 20,
        bc: 3,
        rq:[],
        taxId:0,
        ssflbm:'',
        upload:0,
        voucher:0,
        js:0
      },
      selectQueryType:'1',
      inputQuery: "",
      activeName:'first',
      list:[],
      total: 0,
      contentStyleObj:{}, //高度变化
      formLabelWidth: "100px",
      fromOptions:[
        {
          value:0,
          label:'全部'
        },
        {
          value:1,
          label:'手动添加'
        },
        {
          value:2,
          label:'导入'
        },
        {
          value:3,
          label:'采集'
        },
      ],
      loading:false,
      loadingBig: false,
    }
  },
  computed: {
    // 是否全选
    isAllSelected() {
      if(this.list.length == 0){
        return false
      }
      return this.list.every(el => {
        return el.checked;
      });
    },
  },
  created () {
    this.getList()
    this.contentStyleObj=this.$getHeight(340)
    this.initBus()
  },
  methods:{
    initBus(){
      this.$bus.off("invioceOutUpdate")
      this.$bus.on("invioceOutUpdate", (val) => {
        this.getList()
      });
    },
    selectQuery(){
      if(this.selectQueryType == "1"){
        this.listQuery.fphm = this.inputQuery
        this.listQuery.corpName = ''
      }else{
        this.listQuery.corpName = this.inputQuery
        this.listQuery.fphm = ''
      }
      this.getList()
    },
    //批量补充
    handleBuchongstatus(){
      if(this.selects.length == 0){
        this.$qzfMessage("请至少选择一条", 1)
        return
      }
      this.$refs.outbc.init(this.selects)
    },
    outbcSuccess(){
      this.getList()
    },
    getList(){
      this.loadingBig = true
      outInvoiceList(this.listQuery).then(res=>{
        this.loadingBig = false
        if(res.data.data.list){
          this.list = res.data.data.list
          this.total = res.data.data.total
        }else{
          this.list = []
        }
      })
    },
    // 删除发票
    delALL(){
      if(this.selects.length == 0){
        this.$qzfMessage("请至少选择一条", 1)
        return
      }
      this.loading = true
      let delSelects = []
      this.selects.map(v=>{
        delSelects.push({
          id:v.id
        })
      })
      this.invoiceDel(delSelects)
    },
    delInvoice(row){
      this.invoiceDel([{id: row.id}])
    },
    invoiceDel(ids){
      this.$confirm("确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(()=>{
        delOutInvoice(ids).then(res=>{
          this.loading = false
          if(res.data.msg == "success"){
            this.$qzfMessage("删除成功")
            this.$bus.emit('voucherUpdate')
            this.getList()
          }
        })
      })
    },
    goInfo(id){
      this.$store.dispatch('commons/setParam', {addOutInvoiceId: id})
      this.$store.dispatch('tagsView/delCachedViewByName', "addOutput")
      this.$router.push({
        path: "/input/addOutput",
        name: "addOutput"
      });
    },
    addOutput(e) {
      this.$store.dispatch('commons/setParam', {addOutInvoiceId: 0})
      this.$store.dispatch('tagsView/delCachedViewByName', "addOutput")
      this.$router.push({
        path: "/input/addOutput",  
      });
    },
    //单选
    singleSelect(row, index) {
      row.checked = !row.checked;
      this.list.splice(index, 1, row);
      this.screenChecked()
    },
    // 全选、全不选
    allSelect() {
      let checked = true;
      // 全选
      if (this.isAllSelected) {
        checked = false;
      }
      this.list = this.list.map(el => {
        el.checked = checked;
        return el;
      });
      this.screenChecked()
    },
    screenChecked(){
      this.selects = this.list.filter(v=>{return v.checked})
      console.log(this.selects)
    },
    showVoucher(item){
      this.$refs.voucherShow.getList(item)
    },
    getHandlePingzheng(voucherId) {
      this.$store.dispatch('commons/setParam', {addVoucherId: voucherId})
      this.$store.dispatch('tagsView/delCachedViewByName', "addVoucher")
      this.$router.push({
        path: "/bookkeeps/addVoucher",
        name: "addVoucher"
      });
    },
    handleCommand() {
      oneKeyVoucher({type:'out'}).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("操作成功")
          this.$bus.emit('voucherUpdate')
          this.getList()
        }
      })
    },
    openCom(){
      this.$refs.importBack.handImport()
    },
    openComShougou(){
      this.$refs.importBackShougou.handImport()
    },
    sumsAlert() {
      inOutSum({}).then(res=>{
        this.sums = res.data.data.outSum
        this.sums1 = res.data.data.outSum1
        this.sums2 = res.data.data.outSum2
        this.sums3 = res.data.data.outSum3
        this.sums4 = res.data.data.outSum4
        this.sums5 = res.data.data.outSum5
        let str = `<table style="border:1px solid #c2c2c2;" class="content_table" cellspacing="0" width="100%">
              <tr style="background:#f6f6f6;color:#333;font-weight:600;line-height:32px;">
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;width:40%">类型</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;width:6%"">数量</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;width:18%"">金额</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;width:18%"">税额</td>
                <td style="border-bottom:1px solid #c2c2c2;text-align: center;width:18%"">价税合计</td>
              </tr>
              <tr style="line-height:28px">
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">增值税专用发票</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums1.count}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums1.sum_amount}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums1.sum_tax}</td>
                <td style="border-bottom:1px solid #c2c2c2;text-align: center;">${this.sums1.sum_total}</td>
              </tr>
              <tr style="line-height:28px">
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">增值税普通发票</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums2.count}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums2.sum_amount}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums2.sum_tax}</td>
                <td style="border-bottom:1px solid #c2c2c2;text-align: center;">${this.sums2.sum_total}</td>
              </tr>
              <tr style="line-height:28px">
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">无票</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums3.count}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums3.sum_amount}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums3.sum_tax}</td>
                <td style="border-bottom:1px solid #c2c2c2;text-align: center;">${this.sums3.sum_total}</td>
              </tr>
              <tr style="line-height:28px">
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">增值税电子专用发票</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums4.count}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums4.sum_amount}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums4.sum_tax}</td>
                <td style="border-bottom:1px solid #c2c2c2;text-align: center;">${this.sums4.sum_total}</td>
              </tr>
              <tr style="line-height:28px">
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">增值税电子普通发票</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums5.count}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums5.sum_amount}</td>
                <td style="border-bottom:1px solid #c2c2c2;border-right:1px solid #c2c2c2;text-align: center;">${this.sums5.sum_tax}</td>
                <td style="border-bottom:1px solid #c2c2c2;text-align: center;">${this.sums5.sum_total}</td>
              </tr>
              <tr style="line-height:28px">
                <td style="border-right:1px solid #c2c2c2;text-align: center;">合计</td>
                <td style="border-right:1px solid #c2c2c2;text-align: center;">${this.sums.count}</td>
                <td style="border-right:1px solid #c2c2c2;text-align: center;">${this.sums.sum_amount}</td>
                <td style="border-right:1px solid #c2c2c2;text-align: center;">${this.sums.sum_tax}</td>
                <td style="text-align: center;">${this.sums.sum_total}</td>
              </tr>
            </table>`
        this.$alert(str, '发票统计', {
          confirmButtonText:'确定',
          dangerouslyUseHTMLString: true
        });
      })
    },
    collect(){
      this.$refs.collectSingle.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.left_box {
  float: left;
  margin-top: 11px;
  width: 2%;
  input {
    width: 80%;
    height: 16px;
  }
}
.top-nav {
  height: 36px;
  border: 1px solid #c2c2c2;
  background: #eee;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
  position: relative;
  .box-content {
    box-sizing: border-box;
    text-align: center;
    border-left: 1px solid #c2c2c2;
    line-height: 34px;
    font-size: 14px;
    height: 34px;
  }
}
.right_box {
  float: left;
  width: 98%;
}
.for-content {
    .box-content {
      box-sizing: border-box;
      border-left: 1px solid #c2c2c2;
      text-align: center;
      line-height: 36px;
      height: 36px;
      font-size: 14px;
      border-bottom: 1px solid #c2c2c2;
      padding: 0 10px;
    }
    .el-col:nth-child(10) .box-content {
      // border-bottom: none;
      border-right: 1px solid #c2c2c2;
    }
    .el-col:nth-child(1) .box-content {
      // border-bottom: none;
      border-left: none;
    }
  }
  .table_height{
  overflow-y: overlay;
  overflow-x:hidden;
}
.content-nav {
  line-height: 36px;
  border: 1px solid #c2c2c2;
  .content-top {
    background: #f6f6f6;
    .box-content {
      box-sizing: border-box;
      // border-left: 1px solid #eee;
      text-align: center;
      line-height: 36px;
      height: 36px;
      font-size: 14px;
      border-bottom: 1px solid #c2c2c2;
    }
    .box-content:first-child(1) {
      border-left: none;
    }
  }
  .for-content {
    .box-content {
      box-sizing: border-box;
      border-left: 1px solid #c2c2c2;
      text-align: center;
      line-height: 36px;
      height: 36px;
      font-size: 14px;
      border-bottom: 1px solid #c2c2c2;
      padding: 0 10px;
    }
    .el-col:nth-child(9) .box-content {
      // border-bottom: none;
      border-right: 1px solid #c2c2c2;
    }
    .el-col:nth-child(1) .box-content {
      // border-bottom: none;
      border-left: none;
    }
  }
  .bottom-content {
    .box-content {
      box-sizing: border-box;
      border-left: 1px solid #c2c2c2;
      text-align: center;
      line-height: 36px;
      height: 36px;
      font-size: 14px;
    }
    .el-col:nth-child(1) .box-content {
      border-left: none;
    }
    .el-col:nth-child(7) .box-content {
      border-right: 1px solid #c2c2c2;
    }
  }
}
.top_font {
  float: left;
  width: 90%;
  margin: 0 auto;
  li {
    font-size: 14px;
    color: #333;
    float: left;
    width: 18%;
    text-align: left;
    padding-left: 15px;
    margin-right: 2px;
    &.big {
      // width: 260px
    }
  }
}
.top_right_btns {
  float: right;
  // width: 22%;
  margin-right: 15px;
  i {
    margin: 0 5px;
    cursor: pointer;
    color: $color-main;
    font-size: 18px;
    line-height: 24px;
  }
}
.ccyc{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.dfyhm{
  cursor: pointer;
  border: 1px solid #c2c2c2;
  border-radius: 2px;
  outline: none;
  width: 250px;
  line-height: 20px;
  margin-top: 6px;
}

</style>